// extracted by mini-css-extract-plugin
module.exports = {"root":"EventNameTagsPage_root__MpeSk"};